var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { Accordion, AccordionItem, AccordionItemPadding } from '@inter-ikea-kompis/component-accordion';
import { Text } from '@inter-ikea-kompis/component-text';
import WoodDeclarationCard from '../wood-declaration-card/WoodDeclarationCard.js';
import WoodDeclarationStyle from './WoodDeclarationStyle.js';
const WOOD_DECLARATION_CODE = '00692';
/**
 * Wood declaration component.
 *
 * @event woodDeclarationExpand Triggered when accordion is clicked.
 */
export default class WoodDeclaration extends KompisElement {
    constructor() {
        super(...arguments);
        // Expands the accordion.
        this.woodDeclarationExpanded = false;
    }
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        if (!this.product?.content?.complianceInformation?.find((compliance) => compliance.datasetCode === WOOD_DECLARATION_CODE)) {
            return null;
        }
        return html `
			<style>
				${WoodDeclarationStyle.getStyle()}
			</style>
			<div class="container">
				<kompis-accordion .theme="${this.theme}">
					<kompis-accordion-item
						@expand="${this.onAccordionExpand.bind(this)}"
						.label="${this.getHeader()}"
						.theme="${this.theme}"
						.expanded="${this.woodDeclarationExpanded}"
						.noHorizontalPadding="${true}"
					>
						<kompis-accordion-item-padding .theme="${this.theme}">
							<kompis-wood-declaration-card
								.theme="${this.theme}"
								.product="${this.product}"
							></kompis-wood-declaration-card>
						</kompis-accordion-item-padding>
					</kompis-accordion-item>
				</kompis-accordion>
			</div>
		`;
    }
    connectedCallback() {
        this.customElements.define('kompis-accordion', Accordion);
        this.customElements.define('kompis-accordion-item', AccordionItem);
        this.customElements.define('kompis-accordion-item-padding', AccordionItemPadding);
        this.customElements.define('kompis-text', Text);
        this.customElements.define('kompis-wood-declaration-card', WoodDeclarationCard);
        super.connectedCallback();
    }
    /**
     * Dispatched event for when the accordion expands.
     */
    onAccordionExpand() {
        this.dispatchEvent(new CustomEvent('woodDeclarationExpand', {
            detail: { expand: !this.woodDeclarationExpanded },
            bubbles: true
        }));
    }
    /**
     * Returns header for accordion from data.
     */
    getHeader() {
        const header = this.product.content?.complianceInformation?.find((compliance) => compliance.datasetCode === WOOD_DECLARATION_CODE)?.headingText;
        return header || '';
    }
}
__decorate([
    property({ type: Object, required: true })
], WoodDeclaration.prototype, "theme", void 0);
__decorate([
    property({ type: Boolean })
], WoodDeclaration.prototype, "woodDeclarationExpanded", void 0);
__decorate([
    property({ type: Object, required: true })
], WoodDeclaration.prototype, "product", void 0);
//# sourceMappingURL=WoodDeclaration.js.map